(function () {
    'use strict';

    angular
        .module('app.notesReportSchedule')
        .controller('NotesReportScheduleController', NotesReportScheduleController);

    NotesReportScheduleController.$inject = [
        '$state', '$stateParams', '$window',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function NotesReportScheduleController($state, $stateParams, $window, bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.isNew = isNew;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItem()];

            vm.sendAround = [];
            var h;
            for (var i = 0; i < 24; i++) {
                if (i === 0) {
                    h = "12";
                }
                else {
                    if (i > 12) {
                        h = i % 12;
                    }
                    else {
                        h = i;
                    }
                }

                var desc = (h + ":00");
                desc += Number(i) < 12 ? " AM" : " PM";

                vm.sendAround.push({ "ID": i, "Description": desc })
            }
            
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("admin");
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Notes Report Schedule')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/NotesReport/DeleteSchedule/" + vm.item.Id).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            if (vm.item) {
                return vm.item.Id <= 0;
            }
            return true;
        }

        function getItem() {
            return dataservice.getItem("api/NotesReport/GetSchedule")
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }

        function save() {
            vm.isSaving = true;

            dataservice.saveItem('api/NotesReport/SaveSchedule', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
            
        }

    }
})();
